<div>
  <dss-libs-ui-snackbar-wrapper></dss-libs-ui-snackbar-wrapper>
  <router-outlet></router-outlet>
</div>
<dss-libs-ui-spinner></dss-libs-ui-spinner>
